import React from 'react';

export function Separator() {
  return <div className="mb-2 mb-md-3" />;
}

export function SeparatorSm() {
  return <div className="mb-1 mb-md-2" />;
}
